module.exports = __webpack_public_path__ + "img/logo-login.b2aa7b11.png";